import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivate,
} from '@angular/router';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StorageService } from './shared/services/storage.service';
import { AUTH_TOKEN_KEY } from './shared/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private jwtHelper = new JwtHelperService();

  constructor(
    private router: Router,
    private storageService: StorageService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isLoggedIn()) {
      return true;
    } else {
      this.redirectToLogin(state.url);
      return false;
    }
  }

  private isLoggedIn(): boolean {
    const token = this.storageService.getItem(AUTH_TOKEN_KEY);
    
    if (!token || token === 'null') {
      return false;
    }

    try {
      // Validar que el token no esté expirado
      return !this.jwtHelper.isTokenExpired(token);
    } catch (error) {
      // Token inválido o malformado
      console.error('Error validating token:', error);
      this.storageService.clear();
      return false;
    }
  }

  private redirectToLogin(returnUrl?: string): void {
    // Guardar la URL a la que intentaba acceder para redirigir después del login
    this.router.navigate(['/auth/login'], {
      queryParams: returnUrl ? { returnUrl } : {}
    });
  }
}
